import { default as gql } from "tagged-template-noop";

/**
 * GraphQL mutation for retrieving the AfterPay client token.
 * This mutation is used to generate an AfterPay client token for a specific bag.
 *
 * @typedef {Object} GetAfterPayClientTokenVariables
 * @property {string} redirectConfirmUrl - The URL to redirect to after confirming the payment.
 * @property {string} redirectCancelUrl - The URL to redirect to if the payment is canceled.
 * @property {string} [bagId] - The ID of the bag for which the token is being generated (optional).
 *
 * @typedef {Object} GetAfterPayClientTokenResponse
 * @property {string} getAfterPayClientToken - The generated AfterPay client token.
 */
export const getAfterPayClientTokenMutation = gql`
  mutation getAfterPayClientToken(
    $redirectConfirmUrl: String!
    $redirectCancelUrl: String!
    $bagId: String
  ) {
    getAfterPayClientToken(
      redirectConfirmUrl: $redirectConfirmUrl
      redirectCancelUrl: $redirectCancelUrl
      bagId: $bagId
    )
  }
`;
